import React from "react";
import "../../Assessts/Styles/SamagraDashboard/Participations.scss";

import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const StudentParticipation = (props) => {
  const total = 1278;
  const participated = 1259;
  const absent = 19;

  const chartData = {
    labels: ["Participated", "Absent"],
    datasets: [
      {
        data: [props.PRCount?.participated, props.PRCount?.registered - props.PRCount?.participated],
        backgroundColor: ["#19b97d", "#ef4444"],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    cutout: "55%",
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  return (
    <div className="participation-container mt-3">
      <div className="Sheader">
        <h1>Student Participation</h1>
        <p>
          Detailed participation metrics across grades and school sections
        </p>
      </div>

      <div className="content">

        {/* Left Card */}
        <div className="card">
          <h2>Overall Participation Rate</h2>

          <div className="chart">
            <Doughnut data={chartData} options={options} />
          </div>
        </div>

        {/* Right Card */}
        <div className="card">
          <h2>Participation Breakdown</h2>

          <div className="info-card blue">
            <div className="left">
              <div className="icon">👥</div>

              <div>
                <h3>Total Registered</h3>
                <p>Total enrollment</p>
              </div>
            </div>

            <div className="right">
              <h1>{props.PRCount?.registered}</h1>
            </div>
          </div>

          <div className="info-card green">
            <div className="left">
              <div className="icon">✅</div>

              <div>
                <h3>Participated</h3>
                <p>Completed assessment</p>
              </div>
            </div>

            <div className="right">
              <h1>{props.PRCount?.participated}</h1>
              <span>{(props.PRCount?.participated/props.PRCount?.registered)*100}% of total</span>
            </div>
          </div>

          <div className="info-card red">
            <div className="left">
              <div className="icon">❌</div>

              <div>
                <h3>Did Not Participate</h3>
                <p>Absent or no results</p>
              </div>
            </div>

            <div className="right">
              <h1>{props.PRCount?.registered - props.PRCount?.participated}</h1>
              <span>{((props.PRCount?.registered - props.PRCount?.participated)/props.PRCount?.registered)*100}% of total</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default StudentParticipation;